import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
  checkColumns,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function MarketByTechnology({ marketByTechnology, compView }) {
  const [tabData, setTabData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([
    "key_customer_segments",
    "key_products",
    "strategic_significance",
  ]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");
  const [chartData, setChartData] = useState({});

  let allMetrics = [];

  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        { key: "technology_market_size", label: "Market Size", width: "100px" },
        { key: "technology_cagr", label: "CAGR", width: "90px" },
        // {
        //   key: "company_market_share",
        //   label: "Share",
        //   width: "140px",
        // },
        {
          key: "company_market_revenue_percentage",
          label: "Revenue Contribution (%)",
        },
        // { key: "company_position", label: "Company Focus", width: "145px" },
      ];
      setHiddenColumns([]);
      setColumns(allMetrics);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "technology_segment", label: "Segment Name" },
        { key: "technology_market_size", label: "Market Size", width: "100px" },
        { key: "technology_cagr", label: "CAGR", width: "90px" },
        //Below field not displyed as asked by Dibya
        // {
        //   key: "company_market_share",
        //   label: "Share",
        //   width: "140px",
        // },
        {
          key: "company_market_revenue_percentage",
          label: "Revenue Contribution (%)",
        },
        // {
        //   key: "company_market_size",
        //   label: "Company Market Size",
        //   width: "160px",
        // },
        { key: "company_position", label: "Company Focus", width: "145px" },
        { key: "key_customer_segments", label: "Key Customer Segments" },
        { key: "key_products", label: "Key Products" },
        { key: "strategic_significance", label: "Strategic Significance" },
      ];
      setHiddenColumns([
        "key_customer_segments",
        "key_products",
        "strategic_significance",
      ]);
      setColumns(allMetrics);
      setSidebarColumns([
        "key_customer_segments",
        "key_products",
        "strategic_significance",
      ]);
    }
    // console.log("METRICS: " + JSON.stringify(allMetrics));
  }, [compView]);

  const dummyData = [
    {
      primary_market: {
        value: "Adhesives & Sealants Market",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      global_market_size: {
        value: "$63.4B globally",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      taylor_position: {
        value: "Small Player",
        // source: "https://placeholder.source.com",
        // data_type: "Qualitative",
        // confidence_score: 0.75,
        // reasoning:
        //   "Generated from internal analysis and stakeholder interviews.",
      },
      competitive_ranking: {
        value: "Top 50+ player",
      },
      strategic_significance: {
        value: "Global industry context",
      },
    },
    // Second entry (Post-Acute Care) → similar structure
  ];

  useEffect(() => {
    // setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(marketByTechnology);

    // Check if columns meet multiple conditions
    const columnConditions = {
      company_market_share: ["lessThan1"],
    };

    if (checkColumns(Object.values(transformed), columnConditions)) {
      setHiddenColumns((prev) => [...prev, ...Object.keys(columnConditions)]);
    }

    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(
      <ParsedTextWithLinks
        text={marketByTechnology?.[0]?.response?.["tableComments"] || ""}
      />
      // )
    );

    let tempChartData = { data_set: [] };
    transformed.forEach((marketData) => {
      tempChartData.data_set.push({
        technology_segment: marketData.technology_segment?.value || "",
        technology_market_size: parseFloat(
          (marketData.technology_market_size?.value !== "Undisclosed"
            ? marketData.technology_market_size?.value || "0"
            : "0"
          ).replace(/[^0-9.]/g, "")
        ),
        technology_cagr: parseFloat(
          (marketData.technology_cagr?.value !== "Undisclosed"
            ? marketData.technology_cagr?.value || "0"
            : "0"
          ).replace(/[^0-9.]/g, "")
        ),
      });
    });

    if (tempChartData.data_set.length > 0) {
      setChartData(tempChartData);
      // console.log("TECH CHART DATA: ", tempChartData);
    }
  }, [marketByTechnology]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <>
      <InsightTable
        // title="By Technology – North America"
        title="By Technology"
        subtitle=""
        // belowTableDescription="The shocking reality: Taylor's estimated $300M [1][3] revenue represents just 0.47% of the $63.4B [2] global market, yet they've built a sustainable business by owning specific premium segments completely. This reveals their true competitive advantage isn't scale - it's specialization depth that larger players like H.B. Fuller struggle to replicate without cannibalizing their own volume-based strategies."
        belowTableDescription={tableBelowDescription}
        data={tabData}
        // metrics={allMetrics}
        metrics={columns}
        rowIdentifier="technology_segment"
        // extraIdentifierColumns={[
        //   { key: "technology_market_size", label: "Size" },
        //   { key: "technology_cagr", label: "CAGR" },
        // ]}
        // hiddenColumns={["technology_market_size", "technology_cagr"]}
        hiddenColumns={hiddenColumns}
        sidecardColumns={sidebarColumns}
        actions={actions}
        chartId="market_position_by_technology_bubble_chart"
        chartData={chartData}
        chartType="bubble_chart"
        xField="technology_market_size"
        yField="technology_cagr"
        nameField="technology_segment"
        sizeField="technology_market_size"
        colorField="bubble_color"
        xAxisLabel="Market Size (Bn)"
        yAxisLabel="CAGR (%)"
      />
    </>
  );
}

export default MarketByTechnology;
